var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('datatable',{attrs:{"title":"Tags","fields":_vm.fields,"response":_vm.tag_list},on:{"delete":_vm.deleteTag,"create":_vm.createTag,"edit_click":_vm.editClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }